import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Icon } from '../../../common/html/icon'
import { PopupDeleteCompany } from '../../common/popup/PopupDeleteCompany'
import { TYPE_DELETE } from '../../constant'
import { changeFragment } from '../../savedPortfolios/portfoliosOverview/store/slice/sliceComponent'
import {
  removeIdInListIdAll,
  selectCheckboxFollow,
  selectDataTableFollowingList,
} from '../store/slice'
import { delUnFollow, getHeaderFollow } from '../store/thunk'

export const CustomTdActionFollowingList = ({ rowId }) => {
  const dispatch = useDispatch()

  const nameCompany = useSelector(selectDataTableFollowingList)[rowId]
    ?.organizationName
  const listCheckbox = useSelector(selectCheckboxFollow(['listIdsSelected']))
  const isCanNavigate = !Object.values(listCheckbox).some(Boolean)

  const textFollowing = UseI18n('library.main.FOLLOWING_LIST')

  const [isShowDelete, setIsShowDelete] = useState(false)

  const onSubmitDelete = () => {
    dispatch(
      delUnFollow({
        organizationIds: [rowId],
        deleteType: TYPE_DELETE.IN,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(removeIdInListIdAll([rowId]))
        dispatch(changeFragment())
        dispatch(getHeaderFollow({}))
        setIsShowDelete(false)
      })
      .catch(() => {})
  }

  return (
    <div
      style={{
        pointerEvents: !isCanNavigate ? 'none' : 'auto',
      }}
    >
      <Icon
        className="icon-trash-fill"
        style={{ fontSize: 15, color: '#9C9C9C' }}
        onClick={() => setIsShowDelete(true)}
      />
      {isShowDelete && (
        <PopupDeleteCompany
          isShow={isShowDelete}
          setShow={setIsShowDelete}
          onSubmit={onSubmitDelete}
          renderContent={() => (
            <Translate
              value="library.detailsPortfolios.TEXT_DELETE_SINGLE_COMPANY"
              companyName={nameCompany}
              portfolioName={textFollowing}
              dangerousHTML
            />
          )}
        />
      )}
    </div>
  )
}
